import { useEffect } from "react";

export default function SchemaMarkup() {
  useEffect(() => {
    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Stanford Logistics Management",
      "url": "https://stanfordlogistics.net",
      "logo": "https://stanfordlogistics.net/logo.png",
      "description": "Stanford Logistics Management is a sponsor-driven platform that acquires and grows exceptional trucking and logistics companies through disciplined governance and strategic direction.",
      "foundingDate": "2020",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Savannah",
        "addressRegion": "GA",
        "addressCountry": "US"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-201-470-3182",
        "contactType": "Business Inquiries",
        "email": "info@stanfordlogistics.net",
        "areaServed": "US"
      },
      "sameAs": [
        "https://stanfordlogistics.net"
      ]
    };

    // LocalBusiness Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Stanford Logistics Management",
      "image": "https://stanfordlogistics.net/logo.png",
      "url": "https://stanfordlogistics.net",
      "telephone": "+1-201-470-3182",
      "email": "info@stanfordlogistics.net",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Savannah",
        "addressRegion": "GA",
        "addressCountry": "US"
      },
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "17:00"
      }
    };

    // Add schemas to head
    const script1 = document.createElement("script");
    script1.type = "application/ld+json";
    script1.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "application/ld+json";
    script2.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script2);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return null;
}
